import { createIcon } from '@chakra-ui/react';

export const MbeInfo = createIcon({
  displayName: 'MbeInfo',
  viewBox: '0 0 32 32',
  path: (
    <g fill="currentColor" fillRule="evenodd">
      <path d="M16 2.706C8.67 2.706 2.706 8.67 2.706 16S8.67 29.294 16 29.294 29.294 23.33 29.294 16 23.33 2.706 16 2.706M16 30C8.28 30 2 23.72 2 16S8.28 2 16 2s14 6.28 14 14-6.28 14-14 14" />
      <path d="M16 10.764a1.057 1.057 0 0 1 0-2.112 1.057 1.057 0 0 1 0 2.112m0-3.093a2.04 2.04 0 0 0-2.037 2.037A2.04 2.04 0 0 0 16 11.746a2.04 2.04 0 0 0 2.037-2.038A2.04 2.04 0 0 0 16 7.671M16 13.018a.49.49 0 0 0-.49.491v10.33a.49.49 0 0 0 .981 0v-10.33a.49.49 0 0 0-.49-.49" />
    </g>
  ),
});
